export class ThemeEvents {
  static discountUpdate = "discount:update";
}

export class DiscountUpdateEvent extends Event {
  constructor(resource, sourceId) {
    super(ThemeEvents.discountUpdate, { bubbles: true });
    this.detail = { resource, sourceId };
  }
}

document.addEventListener("cart-update", () => {
  // Recalcula sem apagar a escolha; o resultado substitui o cache ao concluir.

  // Auto-recalcular frete se há CEP salvo
  const cartShippingComponent = document.querySelector(
    "cart-shipping-component"
  );

  if (cartShippingComponent) {
    cartShippingComponent.autoRecalculateShipping();
  }
});

// Listener para eventos de desconto (cupons aplicados/removidos)
document.addEventListener("discount:update", () => {
  // Recalcula sem apagar a escolha; o resultado substitui o cache ao concluir.

  // Auto-recalcular frete se há CEP salvo
  const cartShippingComponent = document.querySelector(
    "cart-shipping-component"
  );
  if (cartShippingComponent) {
    cartShippingComponent.autoRecalculateShipping();
  }
});

// Mantém a linha de frete explícita e soma a opção escolhida ao total exibido.
document.addEventListener("shipping:update", ({ detail }) => {
  const priceCents = Math.round((Number(detail.price) || 0) * 100);
  const formatMoney = (cents) => {
    if (window.Shopify && typeof Shopify.formatMoney === "function") {
      return Shopify.formatMoney(cents, window.money_format);
    }
    return new Intl.NumberFormat("pt-BR", {
      style: "currency",
      currency: "BRL",
    }).format(cents / 100);
  };

  document.querySelectorAll(".previewCartTotals.shipping").forEach((row) => {
    const value = row.querySelector("[data-cart-shipping-value], .previewCartTotals-value");
    if (!value) return;

    value.textContent = detail.removed
      ? value.dataset.shippingEmpty || "A calcular"
      : priceCents === 0
        ? "Grátis"
        : formatMoney(priceCents);
    row.classList.toggle("is-calculated", !detail.removed);
  });

  document.querySelectorAll(".previewCartTotals.total").forEach((row) => {
    const value = row.querySelector("[data-cart-total-value]");
    if (!value) return;

    const baseTotal = Number(value.dataset.cartBaseTotal || value.dataset.cartTotalValue || 0);
    const total = detail.removed ? baseTotal : baseTotal + priceCents;
    value.textContent = formatMoney(total);
  });
});
